import { ComponentProps } from 'react';
import dynamic from 'next/dynamic';

import { Theme as SpTheme } from './index.js';

export const Theme = dynamic<
    JSX.LibraryManagedAttributes<typeof SpTheme, ComponentProps<typeof SpTheme>>
>(() => import('./index.js').then(({ Theme }) => Theme), { ssr: false });
